import { IFormData } from "../../modules/Home/types";

const saveHubspotBehavioralProps = (data: IFormData) => {
    const context = (window as any)
    if (true) {
        context._hsq.push([
            'trackCustomBehavioralEvent',
            {
                name: "pe24120356_dados_formulario",
                properties: {
                    email: data.email,
                    nome: data.name,
                    documento: data.document,
                    data_de_nascimento: data.birthdate,
                    telefone: data.phone,
                    bairro: data.district,
                    endereco: data.address,
                    cep: data.zipcode,
                    complemento: data.complement,
                    cidade: data.city,
                    estado: data.state,
                    numero: data.number,
                    aceito_receber_notificacoes: data.notificationsChecked,
                    aceito_renovacao_auto: data.renovationChecked,
                    li_e_concordo_termos_politica: data.termsChecked
                },
            },
        ]);
    }
}

export { saveHubspotBehavioralProps }